import React from "react";

export default function AboutCompanyCard({ data }) {
    return (
        <div
            className={`flex flex-col lg:flex-row items-center gap-6 p-6 bg-white ${data.reverse ? "lg:flex-row-reverse" : ""
                }`}
        >
            <img
                src={data.image}
                alt={data.title}
                className="w-full lg:w-1/2 h-64 object-cover rounded-xl"
            />
            <div className="w-full lg:w-1/2">
                <h3 className="text-xl font-bold mb-2">{data.title}</h3>
                {/* <p className="text-gray-600 mb-4">{data.text}</p> */}
                <blockquote className="italic text-yellow-500 border-l-4 border-yellow-500 pl-4">
                    "{data.quote}"
                </blockquote>
            </div>
        </div>
    );
}